
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbIntegrador extends AppService {
  abstract desativarIntegrador(id: number, senha: string);
  abstract getAllIntegradores(filter: AppFilter);
  abstract getAllIntegradoresAtivos(): Observable<any>;
  abstract getAllContratos(appFilter: AppFilter);
  abstract deletarContrato(id: number);
  abstract saveOrUpdate(integradorId: number, entity: any);
  abstract saveIntegrador(form: any);
  abstract getById(id: number);
  abstract getByDocumento(documento: string);
  abstract formatarData(data: any): Date;
  abstract formatarDataFilter(data: any): Date;
  abstract tratarDataFilter(data);
  abstract tratarData(data);
  abstract getIntegradorContaLogada();
  abstract getAmbienteCustomizado(integradorId: number): Observable<boolean> ;
  abstract ativarNovoModeloBusca(): Observable<void>;
  abstract getPreCadastroIntegrador(uuid: string): Observable<any>;
}
